<template>
    <v-card flat tile height="100%" width="100%" class="transparent" :disabled="disabled">
        <span class="switchlabel">{{label}}</span>
        <label class="switch" style="float:right;">
            <input type="checkbox" v-model="isChecked" @change="switchedHandle" :disabled="disabled">
            <span class="slider">
                <span class="slider-left-label">{{leftLabel}}</span>
                <span class="slider-right-label">{{rightLabel}}</span>
            </span>
        </label>
    </v-card>
</template>

<script>
    export default {
        name: "SSwitch",
        props: {
            label: String,
            leftLabel: String,
            rightLabel: String,
            switched: Boolean,
            disabled: Boolean
        },
        data: () => ({
            isChecked: true,
        }),
        mounted() {
            this.isChecked = this.switched;
        },
        watch: {
            switched() {
                this.isChecked = this.switched;
            }
        },
        methods: {
            switchedHandle() {
                if(!this.disabled) {
                    this.$emit('onvaluechange', this.isChecked);
                }
            }
        }
    };
</script>

<style scoped>
    .switch {
        position: relative;
        display: inline-block;
        width: 70px;
        height: 24px;
        margin-left: 5px;
    }

    .switchlabel {
        height: 16px;
        font-size: 14px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #F73051;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 2px;
        font-size: 10px;
        line-height: 1.07;
        text-align: center;
    }

    .slider span {
        padding-top: 7px;
    }

    .slider-left-label {
        float: left;
        padding-left: 7px;
        color: #ffffff;
    }

    .slider-right-label {
        float: right;
        padding-right: 7px;
        color: #ffffff;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 32px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 2px;
    }

    input:checked + .slider {
        background-color: #23C373;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(30px);
        -ms-transform: translateX(30px);
        transform: translateX(30px);
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>